import { dispatcher, api } from '@unicus/react-ui-kit';

export const LEDGERACCOUNT = 'LEDGERACCOUNT';

export const LEDGERACCOUNT_FILE_IMPORT = 'LEDGERACCOUNT_FILE_IMPORT';
export const LEDGERACCOUNT_FILE_IMPORT_FINISHED =
  'LEDGERACCOUNT_FILE_IMPORT_FINISHED';

export const importFile = (file, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'ledgerAccounts',
    actionType: LEDGERACCOUNT_FILE_IMPORT,
    effect: async () => api.post(`ledger-accounts/import-file`, file),
    onSuccess,
    onFail: () => true
  });
};
